/*
 * This page provides a screen to show audit data.
 * It also provides a layer to check role based access control before showing audit list page.
 */

import { Container, Typography, Box } from "@mui/material";
import { Trans } from "react-i18next";
import withRBAC from "common/core/withRBAC";
import Permission from "types/Permission.enum";
import { Navigate } from "react-router-dom";
import { useUser } from "services/users.service";
import AuditLogsList from "components/AuditLogsList";

function AuditLogs() {
  const user = useUser();
  // component state

  return (
    <Container maxWidth="xl" sx={{ pb: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        height={40}
        marginY={2}
      >
        <Typography variant="h5" alignSelf="center">
          <Trans
            i18nKey="auditLogs.welcomeMessage"
            values={{ firstName: user.data.firstName }}
            components={{
              span: (
                <Typography
                  component="span"
                  variant="inherit"
                  textTransform="capitalize"
                />
              )
            }}
          />
        </Typography>
      </Box>
      <AuditLogsList />
    </Container>
  );
}

export default withRBAC(AuditLogs, {
  requiredPermissions: [Permission.VIEW_ALL_AUDIT_LOGS],
  fallback: <Navigate to="/no-access" />
});
